/** Max length for customer address lines (matches DB-friendly limit for estimates). */
export const CUSTOMER_ADDRESS_MAX_LENGTH = 255;
